import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
 
@Injectable({providedIn:'root'})
export class ApiServiceLogin {
 
  baseURL = environment.urlServerAuth;
  header = new HttpHeaders();

  
  constructor(private http: HttpClient) {

  }
 
  postService(infoUrl:String, json:any): Observable<any> {
    
    return this.http.post(this.baseURL + infoUrl, json ,{headers: this.header})
  }
 
}